// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"f46f0196","588":"e1d6c03b","592":"a5ecb00a","992":"fa5ac01b"}[chunkId] + ".chunk.js";
};